import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { MyAssignedTests } from "./MyAssignedTests";
import { ProgressPanel } from "./ProgressPanel";
import { MotivationCard } from "./MotivationCard";
import { NoticesBar } from "./NoticesBar";

const tabBtn = (on) => ({ flex: 1, padding: "12px 8px", fontSize: 12, fontWeight: 800, letterSpacing: "0.12em", textTransform: "uppercase", background: on ? "var(--qv-red, #E11D2E)" : "transparent", color: "#fff", border: "1px solid rgba(255,255,255,0.14)", cursor: "pointer" });

export const PlayerTestsHub = ({ assigned, reload }) => {
  const [tab, setTab] = useState("tests");
  const [prog, setProg] = useState(null);
  const [mot, setMot] = useState(null);
  const loadProg = () => {
    api.get("/me/test-progress").then((r) => setProg(r.data)).catch(() => setProg([]));
    api.get("/me/test-motivation").then((r) => setMot(r.data)).catch(() => {});
  };
  useEffect(() => { if (tab === "progress") loadProg(); }, [tab]);
  const pending = assigned ? assigned.assignments.filter((a) => a.status === "active" && !["completed", "needs_review"].includes(a.state)).length : 0;
  return (
    <div style={{ marginBottom: 26 }} data-testid="player-tests-hub">
      <div style={{ display: "flex", gap: 6, marginBottom: 14 }}>
        <button style={tabBtn(tab === "tests")} onClick={() => setTab("tests")} data-testid="hub-tab-tests">Mis tests{pending ? ` (${pending})` : ""}</button>
        <button style={tabBtn(tab === "progress")} onClick={() => setTab("progress")} data-testid="hub-tab-progress">Mi progreso</button>
      </div>
      {tab === "tests" && <NoticesBar refreshKey={assigned} />}
      {tab === "tests" && assigned && <MyAssignedTests data={assigned} reload={reload} />}
      {tab === "progress" && <MotivationCard m={mot} />}
      {tab === "progress" && (prog ? <ProgressPanel items={prog} /> : <div style={{ color: "#a3a3a3" }}>Cargando…</div>)}
    </div>
  );
};
